export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "team_reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gains équipe"])},
        "total_earned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cumul des gains"])}
      },
      "en": {
        "team_reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Team rewards"])},
        "total_earned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["total earnings"])}
      }
    }
  })
}
